import { WEEKDAYS, type Weekday } from "@majourneys/shared";

/**
 * Long weekday name in the page language ("Monday", "lundi", "الاثنين").
 * Formatted from a fixed UTC date that fell on that weekday (2026-01-05 was a
 * Monday) and printed in UTC, so neither the server's nor the phone's time
 * zone can shift it to the neighbouring day.
 */
export function weekdayName(day: Weekday, lang: string): string {
  const date = new Date(Date.UTC(2026, 0, 5 + WEEKDAYS.indexOf(day)));
  return new Intl.DateTimeFormat(lang, { weekday: "long", timeZone: "UTC" }).format(date);
}

/** Today's weekday on the venue's clock, not the device's. */
export function venueWeekday(now: Date, timeZone = "Africa/Casablanca"): Weekday {
  const short = new Intl.DateTimeFormat("en-US", { weekday: "short", timeZone })
    .format(now)
    .toLowerCase()
    .slice(0, 3);
  return (WEEKDAYS as readonly string[]).includes(short) ? (short as Weekday) : "mon";
}
